import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import login from './modules/login'
import getters from './getters'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        login
    },
    plugins: [persistedState()],
    getters,
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js